module.exports = __webpack_public_path__ + "media/images/lavita_banner/composed_banner/banner__sponsor__logo-f662fa63a1383075f4c7e49b4765ca25.png";